import { isFunction } from 'lodash';
import React from 'react';
import { Control, Controller, Path } from 'react-hook-form';
import { SwitchField, SwitchFieldProps } from '../ChakraSwitchField';

interface FormSwitchProps<Form extends {}>
  extends Omit<SwitchFieldProps, 'value' | 'onChange'> {
  control: Control<Form>;
  name: Path<Form>;
  onChange?: () => void;
}

export const ChakraFormSwitch = <Form extends {}>({
  control,
  name,
  onChange: onChangeProp,
  ...props
}: FormSwitchProps<Form>) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value, ref } }) => (
      <SwitchField
        {...props}
        onChange={(e) => {
          onChange(e);
          if (isFunction(onChangeProp)) {
            onChangeProp();
          }
        }}
        isChecked={Boolean(value)}
        ref={ref}
      />
    )}
  />
);
